import { Grid } from '@mui/material';
import React, { useState } from 'react';
import InputField from '../../../Components/Input';
import { useDebounce } from '../../../Utils/helperFns';
import AutoCompleteLocation from '../../../Components/AutoCompleteLocation';

const Address = ({
  control,
  errors,
  watch,
  setValue,
  getValues,
  clearErrors,
  trigger,
}: any) => {
  const [load, setLoad] = useState<boolean>(false);
  const [zipCode, setZipCode] = useState('');

  const debouncedSearchTerm = useDebounce(zipCode, 1000);
  const [latLong, setLatLong] = useState<any>(null);

  const zipCodeWatch = watch('zipCode');

  // const fetchAddressInfo = async (code: string): Promise<void> => {
  //   setLoad(true)
  //   try {
  //     const data = await fetchLocation(code)

  //     const addressComponents = data.results[0]?.address_components || []
  //     const geoLocation = data.results[0]?.geometry || null
  //     if (geoLocation) {
  //       setValue('latitude', geoLocation.location.lat)
  //       setValue('longitude', geoLocation.location.lng)
  //     } else {
  //       setValue('latitude', '')
  //       setValue('longitude', '')
  //     }
  //     const city = addressComponents.find(
  //       (component: any) =>
  //         component.types.includes('locality') ||
  //         component.types.includes('political')
  //     )?.long_name
  //     const state = addressComponents.find((component: any) =>
  //       component.types.includes('administrative_area_level_1')
  //     )?.long_name
  //     const country = addressComponents.find((component: any) =>
  //       component.types.includes('country')
  //     )?.long_name
  //     if (city) {
  //       setValue('city', city)
  //       clearErrors('city')
  //     } else {
  //       setValue('city', '')
  //     }
  //     if (state) {
  //       setValue('state', state)
  //       clearErrors('state')
  //     } else {
  //       setValue('state', '')
  //     }

  //     if (country) {
  //       setValue('country', country)
  //       if (country === 'United States') {
  //         //   getAndSetHolidayList()
  //       }
  //       clearErrors('country')
  //     } else {
  //       setValue('country', '')
  //     }
  //     setLoad(false)
  //   } catch (error) {
  //     setLoad(false)
  //   }
  // }

  // useEffect(() => {
  //   if (zipCode) {
  //     fetchAddressInfo(zipCode)
  //   }
  // }, [debouncedSearchTerm])

  const handleOnkeyBlur = (event: any) => {
    const value = event.target.value;
    if (!value) {
      setValue('state', '');
      setValue('city', '');
      setValue('country', '');
    }
    if (value.length > 3) {
      setZipCode(value);
    }
  };

  // const setDetails = (results: any) => {
  //   if (results && results.address_components) {
  //     const country = results.address_components.find((component: any) =>
  //       component.types.includes('country')
  //     )?.long_name
  //     const city = results.address_components.find(
  //       (component: any) =>
  //         component.types.includes('locality') ||
  //         component.types.includes('political')
  //     )?.long_name
  //     const state = results.address_components.find((component: any) =>
  //       component.types.includes('administrative_area_level_1')
  //     )?.long_name
  //     const zipCode = results.address_components.find((component: any) =>
  //       component.types.includes('postal_code')
  //     )?.long_name
  //     if (city) {
  //       setValue('city', city)
  //       clearErrors('city')
  //     } else {
  //       setValue('city', '')
  //     }
  //     if (state) {
  //       setValue('state', state)
  //       clearErrors('state')
  //     } else {
  //       setValue('state', '')
  //     }
  //     if (country) {
  //       setValue('country', country)
  //       clearErrors('country')
  //       // trigger()
  //     } else {
  //       setValue('country', '')
  //     }
  //     if (zipCode) {
  //       setValue('zipCode', zipCode)
  //       clearErrors('zipCode')
  //       // fetchAddressInfo(zipCode)
  //       // trigger()
  //     } else {
  //       setValue('zipCode', '')
  //     }
  //   } else {
  //     setValue('city', '')
  //     setValue('state', '')
  //     setValue('country', '')
  //     setValue('zipCode', '')
  //   }
  // }

  //   const handleOnblur = (event: any) => {
  //     if (zipCodeWatch) {
  //       console.log('yesss')
  //       fetchAddressInfo(zipCodeWatch)
  //     } else if (zipCodeWatch === '') {
  //       setValue('city', '')
  //       setValue('state', '')
  //       setValue('country', '')
  //       // setValue('address', '');
  //     }
  //   }

  const setDetails = (results: any, newValue: any) => {
    // console.log('RES =>>>', results)
    if (!results || !results.address_components) {
      // Reset fields if no results are available
      setValue('city', '');
      setValue('state', '');
      // setValue('country', '');
      setValue('zipCode', '');
      setValue('addressLine2', '');
      setValue('addressLine1', '');
      setValue('latitude', '');
      setValue('longitude', '');
      setValue('locationName', '');
      return;
    }

    const addressComponents = results.address_components;

    const getAddressComponent = (type: string) => {
      return (
        addressComponents?.find((component: any) =>
          component.types.includes(type),
        )?.long_name || ''
      );
    };

    const country = getAddressComponent('country');
    const state = getAddressComponent('administrative_area_level_1');
    const city =
      getAddressComponent('locality') ||
      getAddressComponent('sublocality') ||
      getAddressComponent('postal_town') || // Used in some countries
      getAddressComponent('administrative_area_level_2'); // Fallback
    const zipCode = getAddressComponent('postal_code');
    const addressLine2 = getAddressComponent('subpremise');
    const [addressLine1, ...rest] = results?.formatted_address.split(',');
    const locationName = newValue?.structured_formatting?.main_text ?? '';

    let addressHolder = '';

    for (const component of results.address_components) {
      if (component.types?.includes('street_number')) {
        if (addressHolder.length) {
          addressHolder = `${component.long_name} ${addressHolder}`;
        } else {
          addressHolder = component.long_name;
        }
      } else if (component.types.includes('route')) {
        addressHolder = `${addressHolder} ${component.long_name}`;
      }
    }

    if (addressHolder.length) {
      setValue('addressLine1', addressHolder);
    }

    const finalLocationName =
      addressHolder?.trim() === locationName?.trim() ? '' : locationName;
    console.log(zipCode, 'wjgfjevjhfvj');
    setValue('city', city);
    setValue('state', state);
    setValue('country', country);
    setValue('zipCode', zipCode);
    setValue('locationName', finalLocationName);
    // setValue('addressLine1', addressLine1);
    setValue('addressLine2', addressLine2 || '');
    setValue('latitude', results?.geometry?.location?.lat());
    setValue('longitude', results?.geometry?.location?.lng());

    // Clear errors if values are set
    if (city) clearErrors('city');
    if (state) clearErrors('state');
    // if (country) clearErrors('country');
    if (zipCode) clearErrors('zipCode');
    if (addressLine2) clearErrors('addressLine2');
  };

  const addressValue = watch('address');

  // console.log('addressValue', addressValue)

  return (
    <div className="formContainer">
      <Grid container spacing={2}>
        <Grid item md={4} xs={12}>
          {/* <InputField
            requiredField
            id="state"
            label="Enter Address"
            name="address"
            control={control}
            placeholder="Enter Address"
            error={!!errors['address']}
            helperText={!!errors['address'] ? errors['address'].message : ''}
          /> */}

          {(addressValue || getValues('address') === null) && (
            <AutoCompleteLocation
              requiredField
              labelText="Location"
              name="address"
              control={control}
              setValue={setValue}
              placeHolderText="Select address"
              limit={100}
              setLatLong={setLatLong}
              changeCallBack={(result: any, newValue: any) => {
                setDetails(result, newValue);
                trigger('address');
              }}
              defaultValue={addressValue}
              isObject={true}
              error={!!errors['address']}
              helperText={!!errors['address'] ? errors['address'].message : ''}
            />
          )}
        </Grid>
        <Grid item md={4} xs={12}>
          <InputField
            requiredField
            id="locationName"
            label="Location Name"
            name="locationName"
            placeholder="Enter Location Name"
            error={!!errors.locationName}
            helperText={errors.locationName?.message}
            control={control}
          />
        </Grid>

        <Grid item md={4} xs={12}>
          <InputField
            requiredField
            id="addressLine1"
            label="Address Line 1"
            name="addressLine1"
            placeholder="Enter Address Line 1"
            error={!!errors.addressLine1}
            helperText={errors.addressLine1?.message}
            control={control}
          />
        </Grid>
        <Grid item md={4} xs={12}>
          <InputField
            id="addressLine2"
            label="Address Line 2"
            name="addressLine2"
            placeholder="Enter address line 2"
            control={control}
            // disabled={!editMode}
            error={!!errors['addressLine2']}
            helperText={
              !!errors['addressLine2'] ? errors['addressLine2'].message : ''
            }
            // onKeyUp={handleOnkeyBlur}

            // value={edit ? editDetails?.empName : ''}
          />
        </Grid>
        <Grid item md={4} xs={12}>
          <InputField
            requiredField
            id="zipCode"
            label="Zip / Postal code"
            name="zipCode"
            // type="number"
            placeholder="Enter zip / postal code"
            control={control}
            // disabled={!editMode}
            error={!!errors['zipCode']}
            helperText={!!errors['zipCode'] ? errors['zipCode'].message : ''}
            onKeyUp={handleOnkeyBlur}

            // value={edit ? editDetails?.empName : ''}
          />
        </Grid>
        <Grid item md={4} xs={12}>
          <InputField
            requiredField
            id="city"
            label="City/Town"
            name="city"
            placeholder="Enter city"
            control={control}
            error={!!errors['city']}
            helperText={!!errors['city'] ? errors['city'].message : ''}
          />
        </Grid>

        <Grid item md={4} xs={12}>
          <InputField
            requiredField
            id="state"
            label="State"
            name="state"
            placeholder="Enter state"
            control={control}
            error={!!errors['state']}
            helperText={!!errors['state'] ? errors['state'].message : ''}

            // value={edit ? editDetails?.empName : ''}
          />
        </Grid>
        {/* <Grid item md={4} xs={12}>
          <InputField
            requiredField
            id="country"
            label="Country"
            name="country"
            placeholder="Enter country"
            control={control}
            error={!!errors['country']}
            helperText={!!errors['country'] ? errors['country'].message : ''}
          />
        </Grid> */}
        <Grid item md={4} xs={12}>
          <InputField
            requiredField
            disabled
            id="Latitude"
            label="Latitude"
            name="latitude"
            placeholder="Enter Latitude"
            error={!!errors.latitude}
            helperText={errors.latitude?.message}
            control={control}
          />
        </Grid>

        <Grid item md={4} xs={12}>
          <InputField
            requiredField
            disabled
            id="Longitude"
            label="Longitude"
            name="longitude"
            placeholder="Enter Longitude"
            error={!!errors.longitude}
            helperText={errors.longitude?.message}
            control={control}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default Address;
